import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "70px",
    ...shorthands.gap("12px"),
    ...shorthands.padding("0px", "18px", "0px", "18px"),
    paddingTop: "15px",
    paddingBottom: "15px",
  },
  info: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "auto",
    width: "100%",
  },
  removeButton: {
    ...shorthands.padding(0),
    minWidth: "24px",
    // WCAG 2.5.8 Target Size (Minimum) requires at least 24x24 CSS px for touch targets;
    // the text-only button otherwise shrinks to its line-height and can fall below that
    // on mobile, making it hard to tap accurately (TalkBack/VoiceOver double-tap included).
    minHeight: "24px",
    color: tokens.colorPaletteRedForeground1,
    paddingTop: "5px",
  },
  editButton: {
    ...shorthands.padding(0),
    minWidth: "24px",
    minHeight: "24px",
    color: tokens.colorBrandForeground1,
    paddingTop: "5px",
  },

  subTitle: {
    maxWidth: "70vw",
    color: tokens.colorNeutralForeground1,
  },
  buttonsContainer: {
    display: "flex",
    // DOM order (Edit, then Remove in CartEntry.tsx) now matches this visual order directly,
    // instead of relying on row-reverse to flip a Remove-then-Edit DOM order. A visual order
    // that diverges from DOM order is a known VoiceOver/WebKit bug that can make swipe
    // navigation skip the reordered elements and break touch-to-activate hit-testing.
    flexDirection: "row",
    ...shorthands.gap("10px"),
  },
  customInstructions: {
    color: tokens.colorNeutralForeground4,
  },
  visuallyHidden: {
    position: "absolute",
    width: "1px",
    height: "1px",
    ...shorthands.padding("0"),
    ...shorthands.margin("-1px"),
    ...shorthands.overflow("hidden"),
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    ...shorthands.borderWidth("0"),
  },
});
